<mc-drawer [open]="open" (closed)="onCloseDrawer($event)" backdropcloseactiondisabled>
  <span slot="heading">Upload Vessel Work Order File</span>

  <article>
    <div class="pure-g m-b-16">
      <div class="pure-u-1">
        <mc-select
          fit="small"
          label="Vessel Shop"
          placeholder="Select a vessel shop"
          ngDefaultControl
          [invalid]="maintenanceShopCodeControl.invalid && maintenanceShopCodeControl.touched"
          errormessage="Vessel shop is required"
          (optionselected)="onShopSelected($event)">
          @for (shop of vesselShops; track shop.maintenanceShopCode) {
            <mc-option [value]="shop.maintenanceShopCode">{{ shop.maintenanceShopCode }} {{ shop.maintenanceShopName }}</mc-option>
          }
        </mc-select>
      </div>
    </div>

    <div class="pure-g">
      <div class="pure-u-1">
        <mc-file-upload
          class="mc-file-upload_drag-drop"
          variant="drag-drop"
          label="Upload vessel work order file"
          hint="Only .xlsx format is allowed"
          accept=".xlsx"
          [invalid]="!!uploadErrorMessage"
          [errormessage]="uploadErrorMessage"
          fit="small"
          (input)="onFileChange($event)">
        </mc-file-upload>
      </div>
    </div>
  </article>

  <mc-button slot="footer" appearance="neutral" dialogaction="cancel" [disabled]="isSubmitting">Cancel</mc-button>
  <mc-button
    slot="footer"
    appearance="primary"
    [loading]="isSubmitting"
    [disabled]="!canSubmit"
    (click)="onSubmit()"
    (keydown.space)="$event.preventDefault(); onSubmit()">
    Submit
  </mc-button>
</mc-drawer>
